module.exports = __webpack_public_path__ + "img/TransactionIcon.92649612.svg";